export default __webpack_public_path__ + "static/media/Shipping.35781349.jpg";